<template>
  <div class="directorWrap">
    <el-dialog class="dialogWrap" title="" :visible.sync="visible" width="1100px" top="1vh" :close-on-click-modal="false" append-to-body>
      <el-tabs v-model="memberType" @tab-click="cutType" class="pb30">
        <!-- 添加公司 -->
        <el-tab-pane :label="$t('enroll.intitle.addCompany')" name="CORPORATE" :disabled="isReadonly">
          <!-- 拷贝 股东/董事信息 -->
          <div>
            <el-dropdown trigger="click" placement="bottom-start" :disabled="isReadonly" @command="commandHandle">
              <span class="crp el-dropdown-link">
                {{ $t("enroll.questionnaire.copyShareholderOrDirectors") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <template v-if="copyFromList.length != 0">
                  <el-dropdown-item v-for="(item, idx) of copyFromList" :key="`company-${idx}`" :command="item">
                    [{{ $t("enroll.questionnaire.companyForm") }}]{{ item.fullName }} / {{ item.email }}
                  </el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item disabled>{{ $t("common.placeholder.noData") }}</el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
            <p class="pt4 fs12 lh16 crgy919">{{ $t("enroll.questionnaire.copyShareholderOrDirectorsHint") }}</p>
          </div>
          <!-- 公司类型 - 表单面板 -->
          <company-form-panel ref="companyPanel" :form="companyForm" :isReadonly="isReadonly" :isMalaysia="isMalaysia" @submit="handleSubmit('companyForm')"></company-form-panel>
        </el-tab-pane>

        <!-- 添加个人 -->
        <el-tab-pane :label="$t('enroll.intitle.addPersonal')" name="INDIVIDUAL" :disabled="isReadonly">
          <!-- 拷贝 股东/董事信息 -->
          <div>
            <el-dropdown trigger="click" placement="bottom-start" :disabled="isReadonly" @command="commandHandle">
              <span class="crp el-dropdown-link">
                {{ $t("enroll.questionnaire.copyShareholderOrDirectors") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <template v-if="copyFromList.length != 0">
                  <el-dropdown-item v-for="(item, idx) of copyFromList" :key="`personal-${idx}`" :command="item">
                    [{{ $t("enroll.questionnaire.personalForm") }}]{{ item.fullName }} / {{ item.email }}
                  </el-dropdown-item>
                </template>
                <template v-else>
                  <el-dropdown-item disabled>{{ $t("common.placeholder.noData") }}</el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
            <p class="pt4 fs12 lh16 crgy919">{{ $t("enroll.questionnaire.copyShareholderOrDirectorsHint") }}</p>
          </div>
          <!-- 个人类型 - 表单面板 -->
          <personal-form-panel ref="personalPanel" :form="personalForm" :isReadonly="isReadonly" :isMalaysia="isMalaysia" @submit="handleSubmit('personalForm')"></personal-form-panel>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import CompanyFormPanel from "./CompanyFormPanel.vue";
import PersonalFormPanel from "./PersonalFormPanel.vue";
import {
  createCompanyForm,
  createPersonalForm,
  createRepresentativeInfo,
  normalizeCompanyForm,
  normalizePersonalForm,
} from "./formFactory";

export default {
  name: "FinalBeneficiaryAddOrUpdate",
  components: { CompanyFormPanel, PersonalFormPanel },
  props: {
    /** 股东/董事信息列表（用于拷贝功能） */
    shareholderDataList: { type: Array, default: () => [] },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    /** 是否马来西亚（用于显示马来专属的注册地址/服务地址模块） */
    isMalaysia: { type: Boolean, default: false },
  },
  data() {
    return {
      visible: false,
      memberType: "CORPORATE",
      companyForm: createCompanyForm(),
      personalForm: createPersonalForm(),
      getInfoIdx: null,
    };
  },
  computed: {
    copyFromList() {
      return (this.shareholderDataList || []).filter(item => item.memberType === this.memberType);
    },
  },
  methods: {
    init(index, row) {
      this.getInfoIdx = index;
      if (index === "add") {
        this.companyForm = createCompanyForm();
        this.personalForm = createPersonalForm();
        this.memberType = "CORPORATE";
        this.$nextTick(() => {
          if (this.$refs.companyPanel) this.$refs.companyPanel.clearValidate();
          if (this.$refs.personalPanel) this.$refs.personalPanel.clearValidate();
        });
      } else {
        const rowRes = JSON.parse(JSON.stringify(row));
        this.memberType = rowRes.memberType || "CORPORATE";
        if (this.memberType === "CORPORATE") {
          this.companyForm = normalizeCompanyForm(rowRes);
          this.personalForm = createPersonalForm();
          this.$nextTick(() => {
            if (this.$refs.companyPanel) this.$refs.companyPanel.clearValidate();
          });
        } else {
          this.personalForm = normalizePersonalForm(rowRes);
          this.companyForm = createCompanyForm();
          this.$nextTick(() => {
            if (this.$refs.personalPanel) this.$refs.personalPanel.clearValidate();
          });
        }
      }
      // 为空的号码设置默认区号 60(马来西亚)、65(新加坡)
      if (!this.companyForm.phone) this.companyForm.phone = this.isMalaysia ? "60-" : "65-";
      if (!this.companyForm.representativeInfo.phone) this.companyForm.representativeInfo.phone = this.isMalaysia ? "60-" : "65-";
      if (!this.personalForm.phone) this.personalForm.phone = this.isMalaysia ? "60-" : "65-";
      this.visible = true;
    },
    cutType() {
      if (this.$refs.companyPanel) this.$refs.companyPanel.clearValidate();
      if (this.$refs.personalPanel) this.$refs.personalPanel.clearValidate();
    },
    commandHandle(item) {
      // 拷贝股东/董事信息到最终受益人表单
      const targetForm = this.memberType === "CORPORATE" ? this.companyForm : this.personalForm;
      // 保留之前最终受益人上传的文件，避免覆盖
      const urls = targetForm.ultimateBeneficiaryBusinessLicenseUrls || [];
      if (this.memberType === "CORPORATE") {
        this.companyForm = {
          ...createCompanyForm(),
          ...{
            fullName: item.fullName,
            nationality: item.nationality,
            businessLicenseNo: item.businessLicenseNo || null,
            phone: item.phone || "",
            email: item.email || null,
            registeredOfficeAddress: item.registeredOfficeAddress || null,
            operationAddress: item.operationAddress || null,
            incorporationDate: item.incorporationDate || null,
            // 马来西亚专属
            entityType: item.entityType || null,
            companyRegistrationNumber: item.companyRegistrationNumber || null,
            companyType: item.companyType || null,
            placeOfIncorporation: item.placeOfIncorporation || null,
            registeredAddressLine1: item.registeredAddressLine1 || null,
            registeredAddressLine2: item.registeredAddressLine2 || null,
            registeredAddressLine3: item.registeredAddressLine3 || null,
            registeredAddressCity: item.registeredAddressCity || null,
            registeredAddressState: item.registeredAddressState || null,
            registeredAddressPostalCode: item.registeredAddressPostalCode || null,
            registeredAddressCountry: item.registeredAddressCountry || null,
            serviceAddressType: item.serviceAddressType ?? 2,
            serviceAddressLine1: item.serviceAddressLine1 || null,
            serviceAddressLine2: item.serviceAddressLine2 || null,
            serviceAddressLine3: item.serviceAddressLine3 || null,
            serviceAddressCity: item.serviceAddressCity || null,
            serviceAddressState: item.serviceAddressState || null,
            serviceAddressPostalCode: item.serviceAddressPostalCode || null,
            serviceAddressCountry: item.serviceAddressCountry || null,
            ultimateBeneficiaryBusinessLicenseUrls: urls,
            representativeInfo: item.representativeInfo ? JSON.parse(JSON.stringify(item.representativeInfo)) : createRepresentativeInfo(),
          },
        };
      } else {
        this.personalForm = {
          ...createPersonalForm(),
          ...{
            fullName: item.fullName,
            nationality: item.nationality,
            identificationType: item.identificationType,
            identificationNo: item.identificationNo,
            email: item.email || null,
            phone: item.phone || "",
            residentialAddress: item.residentialAddress || null,
            birthDate: item.birthDate || null,
            isHoldShareOfPrcInland: item.isHoldShareOfPrcInland ?? 0,
            holdShareOfPrcEntity: item.holdShareOfPrcEntity || null,
            // 马来西亚专属
            gender: item.gender || null,
            occupation: item.occupation || null,
            race: item.race || null,
            residentialAddressLine1: item.residentialAddressLine1 || null,
            residentialAddressLine2: item.residentialAddressLine2 || null,
            residentialAddressLine3: item.residentialAddressLine3 || null,
            residentialAddressCity: item.residentialAddressCity || null,
            residentialAddressState: item.residentialAddressState || null,
            residentialAddressPostalCode: item.residentialAddressPostalCode || null,
            residentialAddressCountry: item.residentialAddressCountry || null,
            serviceAddressType: item.serviceAddressType ?? 2,
            serviceAddressLine1: item.serviceAddressLine1 || null,
            serviceAddressLine2: item.serviceAddressLine2 || null,
            serviceAddressLine3: item.serviceAddressLine3 || null,
            serviceAddressCity: item.serviceAddressCity || null,
            serviceAddressState: item.serviceAddressState || null,
            serviceAddressPostalCode: item.serviceAddressPostalCode || null,
            serviceAddressCountry: item.serviceAddressCountry || null,
            ultimateBeneficiaryBusinessLicenseUrls: urls,
          },
        };
      }
    },
    // 表单校验通过后的提交(由面板组件触发)
    handleSubmit(formType) {
      const formTypeCopy = formType === "companyForm" ? this.companyForm : this.personalForm;
      this.$emit("update", formTypeCopy, this.getInfoIdx);
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* ====== dialogWrap 深度选择器 ====== */
.dialogWrap ::v-deep {
  .el-dialog__header {
    padding: 15px 20px;
  }
  .el-dialog__headerbtn {
    top: 8px;
    right: 15px;
    font-size: 20px;
  }
  .el-tabs__header {
    margin: 0 0 20px;
  }
  .el-tabs__nav {
    float: none;
    text-align: center;
  }
  .el-tabs__item {
    font-size: 18px;
    font-weight: bold;
    padding: 0;
    margin: 0 40px;
    &.is-active {
      border-bottom: 2px solid;
    }
  }
  .el-tabs__nav-wrap::after {
    height: 0;
  }
  .el-tabs__active-bar {
    height: 0;
    display: none;
  }
}
</style>

